import { environment } from "../environment";
import { Bookcase } from "../models/bookcase";
import { StateBook } from "../models/books";
import api from "./api";

export async function getUserBookcase(userId: number, stateBook: StateBook | ''): Promise<Bookcase[]> {
  const baseUrl = environment.api.bookcase.getUserBookcase

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{stateBook}', String(stateBook || ''))

  return await api.get(url).then(res => res.data.success);
}

export async function getBookUserBookcase(userId: number, bookId: number): Promise<Bookcase[]> {
  const baseUrl = environment.api.bookcase.getBookUserBookcase

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{bookId}', String(bookId))

  return await api.get(url).then(res => res.data.success);
}



export async function getClubBookcase(userId: number, stateBook: StateBook | ''): Promise<Bookcase[]> {
  const baseUrl = environment.api.bookcase.getClubBookcase

  const url = baseUrl
    .replace('{clubId}', String(userId))
    .replace('{stateBook}', String(stateBook || ''));

  return await api.get(url).then(res => res.data.success);
}

export async function getPagesAndBooksCountByUserId(userId: number): Promise<{ pages, books }> {
  const baseUrl = environment.api.bookcase.getPagesAndBooksCountForUser

  const url = baseUrl
    .replace('{userId}', String(userId))

  return await api.get(url).then(res => res.data.success);
}

export async function getPagesAndBooksCountByClubId(clubId: number): Promise<{ pages, books }> {
  const baseUrl = environment.api.bookcase.getPagesAndBooksCountForClub

  const url = baseUrl
    .replace('{clubId}', String(clubId))

  return await api.get(url).then(res => res.data.success);
}

export async function getLastClubBook(clubId: number): Promise<Bookcase> {
  const baseUrl = environment.api.bookcase.getLastClubBook

  const url = baseUrl
    .replace('{clubId}', String(clubId))

  return await api.get(url).then(res => res.data.success);
}

export async function getLastUserBook(userId: number): Promise<Bookcase> {
  const baseUrl = environment.api.bookcase.getLastUserBook

  const url = baseUrl
    .replace('{userId}', String(userId))

  return await api.get(url).then(res => res.data.success);
}

export async function addBookToUserBookcase(userId: number, bookId: number, values: { state: StateBook, score: number }) {
  const baseUrl = environment.api.bookcase.createUserBookcase

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{bookId}', String(bookId))

  return await api.post(url, values)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}


export async function addBookToClubBookcase(clubId: number, bookId: number, values: { state: StateBook, score: number }) {
  const baseUrl = environment.api.bookcase.createClubBookcase

  const url = baseUrl
    .replace('{clubId}', String(clubId))
    .replace('{bookId}', String(bookId))

  return await api.post(url, values)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function addBookToUserBookcaseByGoogleId(userId: number, bookId: string, values: { state: StateBook, score: number }) {
  const baseUrl = environment.api.bookcase.createUserBookcaseByGoogleId

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{googleId}', String(bookId))

  return await api.post(url, values)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function addBookToClubBookcaseByGoogleId(clubId: number, bookId: string, values: { state: StateBook, score: number }) {
  const baseUrl = environment.api.bookcase.createClubBookcaseByGoogleId

  const url = baseUrl
    .replace('{clubId}', String(clubId))
    .replace('{googleId}', String(bookId))

  return await api.post(url, values)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}
